import { render, staticRenderFns } from "./applicationModel.vue?vue&type=template&id=08a0695a"
import script from "./applicationModel.vue?vue&type=script&lang=js"
export * from "./applicationModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a0695a')) {
      api.createRecord('08a0695a', component.options)
    } else {
      api.reload('08a0695a', component.options)
    }
    module.hot.accept("./applicationModel.vue?vue&type=template&id=08a0695a", function () {
      api.rerender('08a0695a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/applicationManage/applicationModel.vue"
export default component.exports